import { z } from "zod";
/**
 * `createdBy` is a `participantId` (the participant's `id`). The reserved
 * literal `"SYSTEM"` identifies system-generated comments.
 */
export const CommentCreatedBySchema = z.union([
    z.string().uuid(),
    z.literal("SYSTEM"),
]);
export const CommentSchema = z.strictObject({
    id: z.string().uuid(),
    createdBy: CommentCreatedBySchema,
    message: z.string().min(1),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const AddCommentRequestSchema = z.strictObject({
    message: z.string().min(1),
});
export const UpdateCommentRequestSchema = z.strictObject({
    message: z.string().min(1),
});
